import type { IconSvgObject } from './types';

const SquareSquareIcon: IconSvgObject = [
  ["path", { d: "M3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.99994 15V9C7.99994 8.44772 8.44765 8 8.99994 8H14.9999C15.5522 8 15.9999 8.44772 15.9999 9V15C15.9999 15.5523 15.5522 16 14.9999 16H8.99994C8.44765 16 7.99994 15.5523 7.99994 15Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SquareSquareIcon;
